import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable ,  Subject } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
export class BusinessAuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.isBusinessUser();
  }

  isBusinessUser(): Observable<boolean> {
    var subject = new Subject<boolean>();

    this.authService.whoAmI(true).subscribe(
      r => {
        if (r.isBusinessUser) {
          subject.next(true);
        }
        else {
          this.router.navigateByUrl('/');
          subject.next(false);
        }
      },
      error => {
        this.router.navigateByUrl('/');
        subject.next(false);
      });

    return subject.asObservable();
  }
}